import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-lg border border-input bg-card px-3 py-2 text-sm ring-offset-background transition-[color,background-color,border-color,box-shadow] duration-150 ease-house-out file:border-0 file:bg-transparent file:text-sm file:font-semibold placeholder:text-muted-foreground hover:border-slate-400 focus-visible:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:ring-offset-1 aria-[invalid=true]:border-destructive aria-[invalid=true]:ring-destructive/20 read-only:bg-muted/60 disabled:cursor-not-allowed disabled:bg-muted/60 disabled:opacity-60 motion-reduce:transition-none dark:hover:border-slate-600",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
